<article
  class="base"
  [ngClass]="{
  'collapsed' : isCollapsed() ,
  'not-collapsed' : !isCollapsed() ,
 }"
  #base
>
  <app-header class="header"></app-header>
  <app-side-menu class="side-menu"> </app-side-menu>
  <main class="main"><router-outlet></router-outlet></main>
  <app-footer class="footer"></app-footer>
</article>
